<template>
  <v-card class="card" color="primary" height="100%">
    <v-card-title class="font-weight-bold justify-center">Línea de tiempo de elemento</v-card-title>
    <v-card-text>
      <v-container v-if="loading" fluid>
        <v-row align="center" justify="center" style="min-height: 400px">
          <v-col cols="12" align="center">
            <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
            <div class="text-h6 mt-4">Cargando línea de tiempo...</div>
          </v-col>
        </v-row>
      </v-container>
      <v-timeline v-else-if="permutaciones.length > 0">
        <v-virtual-scroll :items="permutaciones" item-height="240" height="670">
          <template v-slot:default="{ item }">
            <v-timeline-item :key="item.idPermutacion" :left="item.idPermutacion % 2 == 0">
              <template v-slot:opposite>
                <span class="font-weight-black secondary--text">{{ item.fecha }}</span>
              </template>
              <v-card class="secondary" color="primary">
                <v-card-title class="justify-center text-subtitle-2 primary--text font-weight-bold">{{
                  item.TipoPermutacion.title
                }}</v-card-title>
                <v-card-text>
                  <div class="text-body-2 primary--text">
                    {{ item.descripcion }}
                  </div>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </template>
        </v-virtual-scroll>
      </v-timeline>
      <template v-else>
        <v-container>
          <v-row>
            <v-col cols="12" align="center">
              <div class="text-h6">Este elemento no cuenta con cambios de puesto ni adscripción registrados.</div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    idPersonal() {
      return this.personal?.idPersonal
    },
    ...mapGetters('permutacion', {
      permutaciones: 'getPermutaciones',
    }),
  },

  async mounted() {
    if (this.idPersonal) {
      this.loading = true
      try {
        await this.fetchPermutacionesByPersonal(this.idPersonal)
      } catch (error) {
        console.error('Error cargando línea de tiempo:', error)
      } finally {
        this.loading = false
      }
    }
  },

  methods: {
    ...mapActions('permutacion', ['fetchPermutacionesByPersonal']),
  },
}
</script>
